import React from 'react'
import * as fn from '../../../../../helper/uiFunctions';
// import useFormApi from "../../../../cmn/docAutomation/useFormApi"
import SarasTooltip from '../../../../../library/notifications/SarasTooltip';
import SarasProgress from '../../../../../library/notifications/progress/SarasProgress';

const ProdJOTaskDashRow = (props) => {
    const { viewData, rowKey } = props;
    // const [popupData, setPopupData] = React.useState(null);
    // const [isOpen, setIsOpen] = React.useState(false);
    const dashRow = React.useRef();

    // let formApi = useFormApi();
    //console.log("worker taskRow details",viewData);
    // const resetPopupData = () => {
    //     setPopupData(null);
    // }
    
    // React.useEffect(resetPopupData,[viewData,rowKey]);
    
    if (!viewData)
        return (null);

    
    //let data = viewData.childRows[0].rowValues;
    const url = fn.getShowDocumentLink(viewData.dataList.valLDT, viewData.rId, "", 1, viewData.dataList.module, viewData.dataList.view);
    const holdRowId = viewData?.rowValues?.taskStatus?.dataList?.holdRowId || 0;
    const holdStatus = viewData?.rowValues?.taskStatus?.dataList?.holdStatus || '';
    const holdStatusDays = viewData?.rowValues?.taskStatus?.dataList?.holdStatusDays || 0;
    const holdLabel = `On Hold: ${holdStatusDays}d`;

    const urlTarget = viewData.dataList.windowTarget ? viewData.dataList.windowTarget : "_blank";

    const getStyle = () => {
        if (viewData.dataList.recordBarStyle) {
            //alert(data.recordBarContainer.dataList.colCssStyle)
            return JSON.parse(viewData.dataList.recordBarStyle)
        }
        else {
            return {color:"#000"}
        }
    }

    const getOutsourceRow = () => {
        if (fn.compareNumber(viewData.rowValues.isOutsourced.val, 1)) {
            return (
                <div>
                    <span>{viewData.rowValues.taskSubTitle.val}</span>
                </div>
            )
        }
        else {
            return (
                <div>
                                <span className='uiBold'>Est</span>
                                <span className='uiSpacerH5'>{viewData.rowValues.taskEstTime.valF}</span>
                                <span className='uiBold'>Act</span>
                                <span className='uiSpacerH5'>{viewData.rowValues.taskActTime.valF}</span>
                                <div className='uiInline' style={{width:'90px'}}>
                                    <JOProgress rowKey={rowKey} progressType="bar" over100IsDelay
                                    value={viewData.rowValues.percentComplete.val} progressClass="primary" 
                                    delayClass="secondary" labelClass="uiUnHighlight uiGrey"/>
                                </div>
                            </div>
            )
        }
    }

    // const loadPopupData = () => {
    //     let customAction = {
    //         actionId: "show",
    //         actionName: "dashComp",
    //         actionParam: {
    //             actionType: "",
    //             dshv_rowId: dashRowId,
    //             tdoctyid: viewData.dataList.valLDT,
    //             elementId: viewData.rId,
    //             hvCompDocTypeName: "Dashboard",
    //             sview: "D",
    //             vreload: 0,
    //             dshs_popup: 1
    //         },
    //         containerKey: "custom",
    //         onSuccess: onSuccess
    //     };

    //     formApi.runGenericAction(customAction, "dashComp", viewData, viewData.headerRows, { masterKeys: formObject.masterKeys }, "", "DashViews", 0, onSuccess);
    // }

    // const onRowHover = () => {
    //     // console.log("dash onRowHover")
    //     if (!popupData) {
    //         loadPopupData();
    //     }
    //     setIsOpen(true);
    // }

    // const renderDashPopup = () => {
    //     //console.log("dash renderDashPopup", isOpen && popupData != null);
    //     if (isOpen && popupData != null) {
    //         return (
    //             <ProdJOTaskMini viewData={popupData} anchorRef={dashRow} />
    //         )
    //     }
    //     else {
    //         return (null)
    //     }
    // }

    // const hidePopup = () => {
    //     // console.log("dash hidePopup", viewData.dataList.taskTitle)
    //     setIsOpen(false);
    // }

    // const onSuccess = (action, containerKey, rowKey, headerKey, response) => {
    //     setPopupData(response.mainViewData);
    // }

    const renderTaskStatus = () => {
        if (!fn.compareNumber(holdRowId, 0)) {
            return (
                <SarasTooltip title={
                    <>
                        <div>Reason: {holdStatus}</div>
                        <div>Since: {holdStatusDays} days</div>
                    </>
                }>
                    <span className="uiChip uiChipRed">{holdLabel}</span>
                </SarasTooltip>
            );
        }

        return (
            <span className="uiChip" style={getStyle()}>{viewData.rowValues.taskStatus.valF}</span>
        );
    }
    
    return (
        <div className="uiRecordContainer uiH110" >
            <a href={url} target={urlTarget}>
                <div className="uiBar" style={{backgroundColor: 'white'}}>
                    <div className="uiInline" >
                        <span className="uiBold">{viewData.rowValues.taskTitle.val}</span> {renderTaskStatus()}
                    </div>
                    <div ref={dashRow} className={`uiInline uiDashRowRCol show-popup ${viewData.rowValues.taskPriority.dataList.colCssClass}`}
                    >
                        <span className="uiCenterLabel">{viewData.rowValues.taskPriority.val}</span>
                    </div>
                </div>
                <div className="uiBarInfo">
                    <div className="uiProdTaskDashPrimaryRow">
                        <SarasTooltip title={viewData.rowValues.taskItemName.valF || ''}>
                            <span className="uiProdTaskDashImage">
                                <a href={viewData.rowValues.taskImage.dataList.lsrc} target="_LargeImage">
                                    <img alt="" height={"100%"} width="100%" src={viewData.rowValues.taskImage.dataList.src} />
                                </a>
                            </span>
                        </SarasTooltip>
                        <span className="uiProdTaskDashItemName">{viewData.rowValues.taskItemName.valF}</span>
                    </div>
                    <div>
                        <span className='uiBold'>Qty</span>
                        <span className='uiSpacerH5'>{viewData.rowValues.taskQuantity.valF}</span>
                        <span className='uiBold'>Issued On</span>
                        <span className='uiSpacerL5'>{viewData.rowValues.taskIssuedOn.val}</span>
                    </div>
                    {getOutsourceRow()}
                    {/* <div>
                        <span className='uiBold'>Est</span>
                        <span className='uiSpacerH5'>{viewData.rowValues.taskEstTime.valF}</span>
                        <span className='uiBold'>Act</span>
                        <span className='uiSpacerH5'>{viewData.rowValues.taskActTime.valF}</span>
                        <div className='uiInline' style={{width:'90px'}}>
                            <JOProgress rowKey={rowKey} progressType="bar" over100IsDelay
                            value={viewData.rowValues.percentComplete.val} progressClass="primary" 
                            delayClass="secondary" labelClass="uiUnHighlight uiGrey"/>
                        </div>
                    </div> */}
                </div>
            </a>
        </div>
    )
}

const JOProgress = (props) => {
    const { value, rowKey, headerKey, progressType, over100IsDelay, progressClass, delayClass, labelClass, ...restProps } = props;

    if( value > 0){
        const isDelay = value > 100 && over100IsDelay ? true : false;

        //console.log("worker delay", isDelay, value, over100IsDelay);

        return (
            <SarasProgress value={value} progressType={progressType || "bar"} 
                progressClass={isDelay? delayClass : progressClass} labelClass={labelClass} {...restProps} />
        )
    }

    return (null);

}

export default ProdJOTaskDashRow
